const knKundli = {
  // Errors & validation
  "please_fill_required_fields": "ದಯವಿಟ್ಟು ಎಲ್ಲಾ ಅಗತ್ಯ ಕ್ಷೇತ್ರಗಳನ್ನು ಭರ್ತಿ ಮಾಡಿ.",
  "invalid_email_format": "ದಯವಿಟ್ಟು ಸರಿಯಾದ ಇಮೇಲ್ ವಿಳಾಸವನ್ನು ನಮೂದಿಸಿ.",
  "invalid_phone_format": "ದಯವಿಟ್ಟು ಸರಿಯಾದ ಫೋನ್ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ.",
  "payment_failed_message": "ಪಾವತಿ ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ ಅಥವಾ ಸಹಾಯವನ್ನು ಸಂಪರ್ಕಿಸಿ.",

  // Header & hero
  "cosmic_career": " ಕುಂಡಲಿ ವರದಿ",
  "journey": "ನಿಮ್ಮ ಸಂಪೂರ್ಣ ಜೀವನ ವಿಶ್ಲೇಷಣೆ",
  "discover_professional_destiny": "ವೈಯಕ್ತಿಕ ವೇದ ಜ್ಯೋತಿಷ್ಯ ವರದಿ — ವೃತ್ತಿ, ಸಂಬಂಧಗಳು, ಆರೋಗ್ಯ ಮತ್ತು ಪರಿಹಾರಗಳು — 24 ಗಂಟೆಗಳಲ್ಲಿ ಲಭ್ಯ.",

  // Form labels
  "full_name": "ಪೂರ್ಣ ಹೆಸರು",
  "enter_complete_name": "ನಿಮ್ಮ ಸಂಪೂರ್ಣ ಹೆಸರನ್ನು ನಮೂದಿಸಿ",
  "gender": "ಲಿಂಗ",
  "male": "ಪುರುಷ",
  "female": "ಸ್ತ್ರೀ",
  "other": "ಇತರೆ",
  "email_address": "ಇಮೇಲ್ ವಿಳಾಸ",
  "email_placeholder": "ninna@email.com",
  "phone_number": "ಫೋನ್ ಸಂಖ್ಯೆ",
  "phone_placeholder": "+91 1234567890",
  "your_birth_date": "ನಿಮ್ಮ ಜನ್ಮ ದಿನಾಂಕ",
  "birth_time": "ಜನ್ಮ ಸಮಯ",
  "birth_place": "ಜನ್ಮ ಸ್ಥಳ",
  "city_state_country": "ನಗರ, ರಾಜ್ಯ, ದೇಶ",
  "preferred_language": "ಆಯ್ಕೆಯ ಭಾಷೆ",
  "english": "🇺🇸 ಇಂಗ್ಲಿಷ್",
  "hindi": "🇮🇳 ಹಿಂದಿ",
  "telugu": "🇮🇳 ತೆಲುಗು",
  "kannada": "🇮🇳 ಕನ್ನಡ",
  "tamil": "🇮🇳 ತಮಿಳು",
  "marathi": "🇮🇳 ಮರಾಠಿ",
  "bengali": "🇮🇳 ಬೆಂಗಾಲಿ",

  // Benefits (what you'll receive)
  "what_youll_receive": "ನಿಮಗೆ ಸಿಗುವದು",
  "life_kundali_20_years": "ಸಮಗ್ರ ಕುಂಡಲಿ — ವೃತ್ತಿ, ಸಂಬಂಧಗಳು, ಆರೋಗ್ಯ ಮತ್ತು ಹಣಕಾಸಿನ ಕ್ಷೇತ್ರಗಳಲ್ಲಿ ದೀರ್ಘಕಾಲದ ಮಾರ್ಗದರ್ಶನ.",
  "detailed_career_path_analysis": " PDF — ಚಾರ್ಟ್‌ಗಳು, ಯೋಗಗಳು, ದಶೆಗಳು, ಗೋಚರಗಳು ಮತ್ತು ದೃಶ್ಯ ವಿವರಣೆಗಳೊಂದಿಗೆ.",
  "planetary_position_interpretations": "ಗ್ರಹ ಸ್ಥಿತಿಗಳು ಮತ್ತು ಭವನಗಳ ಸ್ಪಷ್ಟ ವಿಶ್ಲೇಷಣೆ — ಓದಲು ಸುಲಭವಾದ ಶೈಲಿಯಲ್ಲಿ.",
  "dasha_system_predictions": "ದಶೆ ಮತ್ತು ಗೋಚರ ಆಧಾರಿತ ಭವಿಷ್ಯವಾಣಿಗಳು — ಸರಿಯಾದ ಸಮಯದಲ್ಲಿ ಸರಿಯಾದ ನಿರ್ಧಾರಗಳಿಗೆ ಸಹಾಯಕ.",
  "personalized_remedial_suggestions": "ವೈಯಕ್ತಿಕ ಪರಿಹಾರಗಳು ಮತ್ತು ರತ್ನ ಶಿಫಾರಸುಗಳು — ಕಷ್ಟಕರ ಸಮಯವನ್ನು ಸಮತೋಲನಗೊಳಿಸಲು.",
  "digital_pdf_report": "ಡಿಜಿಟಲ್ PDF — ವಾಟ್ಸಾಪ್ ಅಥವಾ ಇಮೇಲ್ ಮೂಲಕ 24 ಗಂಟೆಗಳಲ್ಲಿ ಕಳುಹಿಸಲಾಗುತ್ತದೆ.",

  // Pricing/checkout
  "unlock_your_destiny_title": "ನಿಮ್ಮ ಸಂಪೂರ್ಣ ವರದಿ ಪಡೆಯಿರಿ",
  "complete_cosmic_journey_desc": "ಫಾರ್ಮ್ ಪೂರ್ತಿ ಮಾಡಿ ಮತ್ತು ನಿಮ್ಮ ವೈಯಕ್ತಿಕ  ಜ್ಯೋತಿಷ್ಯ ವರದಿ ಪಡೆಯಿರಿ.",
  "premium": "ಪ್ರೀಮಿಯಂ ವರದಿ",
  "career_path_analysis": "ಸಂಪೂರ್ಣ ಜೀವನ ವಿಶ್ಲೇಷಣೆ ವರದಿ",
  "processing_payment": "ಪಾವತಿ ಪ್ರಕ್ರಿಯೆ ನಡೆಯುತ್ತಿದೆ...",
  "preparing_analysis": "ನಿಮ್ಮ  ವರದಿ ತಯಾರಾಗುತ್ತಿದೆ...",
  "complete_payment_get_report": "🚀 ಪಾವತಿ ಪೂರ್ಣಗೊಳಿಸಿ ಮತ್ತು ವರದಿ ಪಡೆಯಿರಿ",

  // Trust indicators
  "reports_generated": "15,000+ ವರದಿಗಳು ತಲುಪಿಸಲಾಯಿತು",
  "rating": "ಬಳಕೆದಾರರಿಂದ 4.9/5 ರೇಟಿಂಗ್",
  "secure": "🔒 ಸುರಕ್ಷಿತ ಪಾವತಿ ವಿಧಾನ",

  // API / runtime messages
  "failed_to_load_payment": "ಪಾವತಿ ಗೇಟ್‌ವೇ ಲೋಡ್ ಆಗಲಿಲ್ಲ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
  "failed_to_create_order": "ಆರ್ಡರ್ ರಚಿಸಲಾಗಲಿಲ್ಲ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
  "failed_to_initialize_payment": "ಪಾವತಿ ಪ್ರಾರಂಭ ವಿಫಲವಾಗಿದೆ. ಸ್ವಲ್ಪ ಸಮಯದ ನಂತರ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
  "failed_to_open_payment_gateway": "ಪಾವತಿ ವಿಂಡೋ ತೆರೆಯಲಿಲ್ಲ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",

  // Service details
  "birth_chart_analysis": "ವೈಯಕ್ತಿಕ ಜ್ಯೋತಿಷ್ಯ ವರದಿ",
  "complete_kundli_report": " ವೇದ ಕುಂಡಲಿ ವರದಿ - ಜೀವನದ ಎಲ್ಲಾ ಅಂಶಗಳು",
  "service_amount": "₹599",

  "advanced_astrology_suite": "ಆಧುನಿಕ ಜ್ಯೋತಿಷ್ಯ ಪ್ಯಾಕೇಜ್",
  "suite_summary": "ಟೈಮ್‌ಲೈನ್‌ಗಳು, ಹೊಂದಾಣಿಕೆ ಮತ್ತು ಸ್ಪಷ್ಟ ವಿಶ್ಲೇಷಣೆಯೊಂದಿಗೆ ಆಳವಾದ ಜ್ಯೋತಿಷ್ಯ ವರದಿ — ಓದಲು ಮತ್ತು ಹಂಚಿಕೊಳ್ಳಲು ಸುಲಭ.",
  "feature_reports": "ಸಮಗ್ರ ವರದಿಗಳು — ಸ್ಪಷ್ಟ ಸ್ವರೂಪ ಮತ್ತು ದೃಶ್ಯ ವಿಭಾಗಗಳೊಂದಿಗೆ.",
  "feature_compatibility": "ಹೊಂದಾಣಿಕೆ ವಿಶ್ಲೇಷಣೆ ಮತ್ತು ಟೈಮ್‌ಲೈನ್‌ಗಳು — ಪ್ರಮುಖ ನಿರ್ಧಾರಗಳಿಗೆ ಸಹಾಯಕ.",
  "feature_multilingual": "ಬಹುಭಾಷಾ ವರದಿಗಳು ಮತ್ತು ಮೊಬೈಲ್/ಪರಿಕರ ಸ್ನೇಹಿ ವಿನ್ಯಾಸ.",
  "report_preview_alt": "ವರದಿ ಪೂರ್ವವೀಕ್ಷಣೆ",
  "get_my_report": "ನನ್ನ ವರದಿ ಪಡೆಯಿರಿ",
  "autocomplete_hint": "ನಿಮ್ಮ ನಗರವನ್ನು ಟೈಪ್ ಮಾಡಲು ಪ್ರಾರಂಭಿಸಿ; ಸಲಹೆಗಳು ಸ್ವಯಂಚಾಲಿತವಾಗಿ ತೋರುತ್ತವೆ"
};
export default knKundli;


// const enKundli = {
//   // Error Messages
//   "please_fill_required_fields": "ದಯವಿಟ್ಟು ಎಲ್ಲಾ ಅಗತ್ಯ ಕ್ಷೇತ್ರಗಳನ್ನು ಭರ್ತಿ ಮಾಡಿ.",
//   "invalid_email_format": "ದಯವಿಟ್ಟು ಮಾನ್ಯವಾದ ಇಮೇಲ್ ವಿಳಾಸವನ್ನು ನಮೂದಿಸಿ.",
//   "invalid_phone_format": "ದಯವಿಟ್ಟು ಮಾನ್ಯವಾದ ದೂರವಾಣಿ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ.",
//   "payment_failed_message": "ಪಾವತಿ ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ ಅಥವಾ ಬೆಂಬಲವನ್ನು ಸಂಪರ್ಕಿಸಿ.",

//   // Step Configuration
//   "personal_identity": "ವೈಯಕ್ತಿಕ ಮಾಹಿತಿ",
//   "tell_us_about_yourself": "ಪ್ರಾರಂಭಿಸಲು ನಿಮ್ಮ ಬಗ್ಗೆ ಹೇಳಿ",
//   "birth_details": "ಜನ್ಮ ವಿವರಗಳು",
//   "your_cosmic_coordinates": "ನಿಮ್ಮ ವಿಶ್ಲೇಷಣೆಯನ್ನು ಪ್ರಾರಂಭಿಸಲು ನಮಗೆ ನಿಮ್ಮ ಜನ್ಮ ವಿವರಗಳು ಬೇಕು",
//   "time_and_place": "ಜನ್ಮ ಸಮಯ ಮತ್ತು ಸ್ಥಳ",
//   "when_and_where_arrived": "ನೀವು ಯಾವಾಗ ಮತ್ತು ಎಲ್ಲಿ ಜನಿಸಿದ್ದೀರಿ?",
//   "your_preferences": "ಭಾಷೆಯ ಆದ್ಯತೆ",
//   "customize_experience": "ವರದಿಗಾಗಿ ನಿಮ್ಮ ಆದ್ಯತೆಯ ಭಾಷೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿ",
//   "unlock_your_destiny": "ನಿಮ್ಮ 200+ ಪುಟದ ಕುಂಡಲಿಯನ್ನು ಪಡೆಯಿರಿ",
//   "complete_cosmic_journey": "ಸಂಪೂರ್ಣ ವರದಿಯನ್ನು ಸ್ವೀಕರಿಸಲು ನಿಮ್ಮ ವಿವರಗಳನ್ನು ಪೂರ್ಣಗೊಳಿಸಿ",

//   // Step 0: Personal Details
//   "who_are_you": "ನೀವು ಯಾರು?",
//   "start_with_basics": "ಮೂಲಭೂತ ವಿಷಯಗಳೊಂದಿಗೆ ಪ್ರಾರಂಭಿಸಿ",
//   "full_name": "ಪೂರ್ಣ ಹೆಸರು",
//   "enter_complete_name": "ನಿಮ್ಮ ಸಂಪೂರ್ಣ ಹೆಸರನ್ನು ನಮೂದಿಸಿ",
//   "gender": "ಲಿಂಗ",
//   "male": "ಪುರುಷ",
//   "female": "ಮಹಿಳೆ",
//   "other": "ಇತರೆ",
//   "email_address": "ಇಮೇಲ್ ವಿಳಾಸ",
//   "email_placeholder": "your@email.com",
//   "phone_number": "ದೂರವಾಣಿ ಸಂಖ್ಯೆ",
//   "phone_placeholder": "+91 1234567890",

//   // Step 1: Birth Date
//   "your_birth_date": "ನಿಮ್ಮ ಜನ್ಮ ದಿನಾಂಕ",
//   "cosmic_journey_begin": "ನಿಮ್ಮ ಕಾಸ್ಮಿಕ್ ಪ್ರಯಾಣ ಯಾವಾಗ ಪ್ರಾರಂಭವಾಯಿತು?",
//   "age_label": "ವಯಸ್ಸು",
//   "years": "ವರ್ಷಗಳು",

//   // Step 2: Time & Place
//   "time_and_place_title": "ಜನ್ಮ ಸಮಯ ಮತ್ತು ಸ್ಥಳ",
//   "precise_moment_location": "ನಿಖರವಾದ ಸಮಯ ಮತ್ತು ಸ್ಥಳವು ನಿಖರವಾದ ಲೆಕ್ಕಾಚಾರಗಳನ್ನು ಖಚಿತಪಡಿಸುತ್ತದೆ",
//   "birth_time": "ಜನ್ಮ ಸಮಯ",
//   "select_exact_time": "ನಿಮ್ಮ ನಿಖರವಾದ ಜನ್ಮ ಸಮಯವನ್ನು ಆಯ್ಕೆಮಾಡಿ",
//   "birth_place": "ಜನ್ಮ ಸ್ಥಳ",
//   "city_state_country": "ನಗರ, ರಾಜ್ಯ, ದೇಶ",
//   "location_accuracy": "ಸ್ಥಳದ ನಿಖರತೆ",
//   "exact_birthplace_ensures": "ನಿಖರವಾದ ಜನ್ಮಸ್ಥಳವು ನಿಖರವಾದ ಗ್ರಹಗಳ ಸ್ಥಾನಗಳನ್ನು ಖಚಿತಪಡಿಸುತ್ತದೆ",

//   // Step 3: Preferences
//   "your_preferences_title": "ಭಾಷೆಯನ್ನು ಆರಿಸಿ",
//   "customize_astrological_experience": "ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ವರದಿಗಾಗಿ ಭಾಷೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿ",
//   "preferred_language": "ಆದ್ಯತೆಯ ಭಾಷೆ",
//   "english": "🇺🇸 ಇಂಗ್ಲಿಷ್",
//   "hindi": "🇮🇳 ಹಿಂದಿ",
//   "telugu": "🇮🇳 ತೆಲುಗು",
//   "kannada": "🇮🇳 ಕನ್ನಡ",
//   "tamil": "🇮🇳 ತಮಿಳು",
//   "marathi": "🇮🇳 ಮರಾಠಿ",
//   "bengali": "🇮🇳 ಬಂಗಾಳಿ",
//   "what_youll_receive": "ನೀವು ಏನನ್ನು ಸ್ವೀಕರಿಸುವಿರಿ",
//   "life_kundali_20_years": "20 ವರ್ಷಗಳ ಭವಿಷ್ಯ ಭವಿಷ್ಯವಾಣಿಗಳೊಂದಿಗೆ ಜೀವನ ಕುಂಡಲಿ — ವೃತ್ತಿ, ಪ್ರೀತಿ, ಆರೋಗ್ಯ ಮತ್ತು ಸಂಪತ್ತಿಗಾಗಿ ವರ್ಷದಿಂದ ವರ್ಷಕ್ಕೆ ಮಾರ್ಗದರ್ಶನ",
//   "detailed_career_path_analysis": "200+ ಪುಟದ PDF ಕುಂಡಲಿ ವರದಿ",
//   "planetary_position_interpretations": "20+ ಜ್ಯೋತಿಷ್ಯ ವ್ಯವಸ್ಥೆಗಳನ್ನು ಒಳಗೊಳ್ಳುತ್ತದೆ",
//   "dasha_system_predictions": "ವೃತ್ತಿ, ಮದುವೆ, ಆರೋಗ್ಯ ಮತ್ತು ಜೀವನ ಭವಿಷ್ಯವಾಣಿಗಳನ್ನು ಒಳಗೊಂಡಿದೆ",
//   "personalized_remedial_suggestions": "ವೈಯಕ್ತಿಕ ಪರಿಹಾರಗಳು ಮತ್ತು ರತ್ನ ಸಲಹೆಗಳು",
//   "digital_pdf_report": "24 ಗಂಟೆಗಳೊಳಗೆ WhatsApp ಅಥವಾ ಇಮೇಲ್ ಮೂಲಕ ತಲುಪಿಸಲಾಗುತ್ತದೆ",

//   // Step 4: Payment
//   "unlock_your_destiny_title": "ನಿಮ್ಮ ಸಂಪೂರ್ಣ ವರದಿಯನ್ನು ಪಡೆಯಿರಿ",
//   "complete_cosmic_journey_desc": "ಫಾರ್ಮ್ ಅನ್ನು ಪೂರ್ಣಗೊಳಿಸಿ ಮತ್ತು ನಿಮ್ಮ ವೈಯಕ್ತಿಕ 200+ ಪುಟದ ಜ್ಯೋತಿಷ್ಯ ವರದಿಯನ್ನು ಸ್ವೀಕರಿಸಿ",
//   "premium": "ಪ್ರೀಮಿಯಂ ವರದಿ",
//   "career_path_analysis": "ಸಂಪೂರ್ಣ ಜೀವನ ವಿಶ್ಲೇಷಣೆ ವರದಿ",
//   "off_label": "ರಿಯಾಯಿತಿ",
//   "summary_of_details": "ನಿಮ್ಮ ಸಾರಾಂಶ:",
//   "name_label": "ಹೆಸರು:",
//   "birth_date_label": "ಜನ್ಮ ದಿನಾಂಕ:",
//   "birth_time_label": "ಜನ್ಮ ಸಮಯ:",
//   "birth_place_label": "ಜನ್ಮ ಸ್ಥಳ:",
//   "processing_payment": "ಪಾವತಿಯನ್ನು ಪ್ರಕ್ರಿಯೆಗೊಳಿಸಲಾಗುತ್ತಿದೆ...",
//   "preparing_analysis": "ನಿಮ್ಮ 200+ ಪುಟದ ವರದಿಯನ್ನು ರಚಿಸಲಾಗುತ್ತಿದೆ...",
//   "complete_payment_get_report": "🚀 ಪಾವತಿ ಪೂರ್ಣಗೊಳಿಸಿ ಮತ್ತು ವರದಿ ಪಡೆಯಿರಿ",

//   // Navigation
//   "previous": "← ಹಿಂದಿನದು",
//   "step_of": "ಹಂತ",
//   "of": "ರಲ್ಲಿ",
//   "next": "ಮುಂದೆ →",
//   "review_and_pay": "ಪರಿಶೀಲಿಸಿ ಮತ್ತು ಪಾವತಿಸಿ",

//   // Validation Messages
//   "fill_personal_details": "ದಯವಿಟ್ಟು ಎಲ್ಲಾ ಅಗತ್ಯವಾದ ವೈಯಕ್ತಿಕ ವಿವರಗಳನ್ನು ಭರ್ತಿ ಮಾಡಿ",
//   "select_birth_date": "ದಯವಿಟ್ಟು ನಿಮ್ಮ ಜನ್ಮ ದಿನಾಂಕವನ್ನು ಆಯ್ಕೆಮಾಡಿ",
//   "provide_birth_time_place": "ದಯವಿಟ್ಟು ನಿಖರವಾದ ಜನ್ಮ ಸಮಯ ಮತ್ತು ಸ್ಥಳವನ್ನು ಒದಗಿಸಿ",

//   // Header
//   "cosmic_career": "200+ ಪುಟದ ಕುಂಡಲಿ ವರದಿ",
//   "journey": "ನಿಮ್ಮ ಸಂಪೂರ್ಣ ಜೀವನ ವಿಶ್ಲೇಷಣೆ",
//   "discover_professional_destiny": "24 ಗಂಟೆಗಳಲ್ಲಿ ತಲುಪಿಸಲಾಗುವ ವೃತ್ತಿ, ಪ್ರೀತಿ, ಆರೋಗ್ಯ ಮತ್ತು ಪರಿಹಾರಗಳೊಂದಿಗೆ ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ವೈದಿಕ ಜ್ಯೋತಿಷ್ಯ ವರದಿಯನ್ನು ಪಡೆಯಿರಿ. 20 ವರ್ಷಗಳ ಭವಿಷ್ಯ ಭವಿಷ್ಯವಾಣಿಗಳೊಂದಿಗೆ ಜೀವನ ಕುಂಡಲಿ — ವೃತ್ತಿ, ಪ್ರೀತಿ, ಆರೋಗ್ಯ ಮತ್ತು ಸಂಪತ್ತಿಗಾಗಿ ವರ್ಷದಿಂದ ವರ್ಷಕ್ಕೆ ಮಾರ್ಗದರ್ಶನ",

//   // Trust Indicators
//   "reports_generated": "15,000+ ವರದಿಗಳನ್ನು ತಲುಪಿಸಲಾಗಿದೆ",
//   "rating": "ಬಳಕೆದಾರರಿಂದ 4.9/5 ರೇಟಿಂಗ್",
//   "secure": "🔒 ಸುರಕ್ಷಿತ ಮತ್ತು ಸಂರಕ್ಷಿತ ಪಾವತಿ",

//   // Thank You Page Service Features
//   "detailed_career_guidance_pdf": "ಸಂಪೂರ್ಣ ವೃತ್ತಿ ಮತ್ತು ಜೀವನ ಮಾರ್ಗ ಮಾರ್ಗದರ್ಶನ",
//   "comprehensive_astrological_analysis": "20+ ಜ್ಯೋತಿಷ್ಯ ವ್ಯವಸ್ಥೆಗಳ ಆಧಾರದ ಮೇಲೆ",
//   "planetary_positions_interpretations": "ದಶಾ, ಗೋಚರ, ನಕ್ಷತ್ರ, ಸಂಖ್ಯಾಶಾಸ್ತ್ರವನ್ನು ಒಳಗೊಂಡಿದೆ",
//   "dasha_system_predictions_feature": "ಭವಿಷ್ಯ ಭವಿಷ್ಯವಾಣಿಗಳು, ಗ್ರಹಗಳ ಟೈಮ್‌ಲೈನ್‌ಗಳು",
//   "personalized_remedial_suggestions_feature": "ಕಸ್ಟಮ್ ಪರಿಹಾರಗಳು, ರತ್ನಗಳು ಮತ್ತು ದೋಷ ವರದಿಗಳು",

//   // API Related Messages
//   "failed_to_load_payment": "ಪಾವತಿ ಗೇಟ್‌ವೇ ಲೋಡ್ ಆಗಲು ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
//   "failed_to_create_order": "ಆರ್ಡರ್ ರಚಿಸಲು ಸಾಧ್ಯವಾಗಲಿಲ್ಲ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
//   "failed_to_initialize_payment": "ಪಾವತಿಯನ್ನು ಪ್ರಾರಂಭಿಸಲು ವಿಫಲವಾಗಿದೆ. ಸ್ವಲ್ಪ ಸಮಯದ ನಂತರ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
//   "failed_to_open_payment_gateway": "ಪಾವತಿ ವಿಂಡೋವನ್ನು ತೆರೆಯಲು ಸಾಧ್ಯವಾಗಲಿಲ್ಲ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",

//   // Service Details
//   "birth_chart_analysis": "ವೈಯಕ್ತಿಕ ಜ್ಯೋತಿಷ್ಯ ವರದಿ",
//   "complete_kundli_report": "200+ ಪುಟದ ವೈದಿಕ ಕುಂಡಲಿ ವರದಿ - ಎಲ್ಲಾ ಜೀವನ ಕ್ಷೇತ್ರಗಳನ್ನು ಒಳಗೊಂಡಿದೆ",
//   "service_amount": "₹599",

//   // Time of Day Indicators (for emoji display)
//   "morning": "🌅",
//   "afternoon": "☀️",
//   "evening": "🌆",
//   "night": "🌙",

//   // Days of Week
//   "monday": "ಸೋಮವಾರ",
//   "tuesday": "ಮಂಗಳವಾರ",
//   "wednesday": "ಬುಧವಾರ",
//   "thursday": "ಗುರುವಾರ",
//   "friday": "ಶುಕ್ರವಾರ",
//   "saturday": "ಶನಿವಾರ",
//   "sunday": "ಭಾನುವಾರ",

//   // Months
//   "january": "ಜನವರಿ",
//   "february": "ಫೆಬ್ರವರಿ",
//   "march": "ಮಾರ್ಚ್",
//   "april": "ಏಪ್ರಿಲ್",
//   "may": "ಮೇ",
//   "june": "ಜೂನ್",
//   "july": "ಜುಲೈ",
//   "august": "ಆಗಸ್ಟ್",
//   "september": "ಸೆಪ್ಟೆಂಬರ್",
//   "october": "ಅಕ್ಟೋಬರ್",
//   "november": "ನವೆಂಬರ್",
//   "december": "ಡಿಸೆಂಬರ್"
// };
// export default enKundli;
